// extracted by mini-css-extract-plugin
module.exports = {"garderobo":"ButtonBack_garderobo__3tTeK","garderobo--gap-big":"ButtonBack_garderobo--gap-big__2eVVV","garderobo--gap-small":"ButtonBack_garderobo--gap-small__2UXQ7"};